<template>
  <img :class="getClassName" :src="require(`@/assets/icons/${name}.svg`)" />
</template>
<script>
export default {
  props: {
    name: String,
    className: String,
  },
  computed: {
    getClassName() {
      let className = "icon";
      if (this.className) className += ` ${this.className}`;
      return className;
    },
  },
};
</script>
